import * as React from "react"
import Seo from "../components/seo"
import Layout from "../components/layout"
import { Link } from "gatsby"

export default function NotFoundPage() {
  return (
    <Layout isNotFound={true}>
      <Seo
        type="article"
        title="404"
        description=""
        bobyClassName="menu"
        path="404"
      />
      <div className="wrapper">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/404" className="current">404</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        <div className="catch1">
          <div className="catch1_in">
            <div className="catch_title">
              <h2 className="maintitle"><span>404</span></h2>
              <p className="subtitle"><span>お探しのページが見つかりません</span></p>
            </div>
          </div>{/* catch_in */}
        </div>{/* /catch1 */}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}

        <div className="wrapper_contents">
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
          <div className="contents contents_wrap">
            <div className="contents_in">
              <div className="padding_sp">{/* スマホのみ隙間 */}
                <div className="errer404_cnt_wrap w730">
                  <div className="cnt_wrap">
                    <p className="t_center" style={{paddingTop: '100px'}}>あなたがアクセスしたページは、削除されたかURLが変更されているため表示することができません。</p>
                  </div>
                </div>
              </div>{/* padding_sp スマホのみ隙間 */}
            </div>{/* contents_in */}
          </div>{/* /contents */}
          {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
          </div>{/* main */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}
